import { useMap } from 'react-leaflet';
import { useEffect } from "react";
import PropTypes from 'prop-types';

const LocationFilter = (props) => {
  const {label, checked, onCheck} = props;
  const map = useMap();

  useEffect(() => {
    const filter = L.control({ position: "bottomleft" });

    filter.onAdd = () => {
      const div = L.DomUtil.create("div", "custom-control custom-checkbox my-1 me-sm-2");

      let html = `<input class='custom-control-input' type='checkbox' ${checked ? 'checked' : ''} id='filterInput'>`;
      html += `<label class='custom-control-label' for='filterInput'>${label}</label>`;

      div.innerHTML = html;
      L.DomEvent.on(div.firstElementChild, 'click', onCheck);

      return div;
    };

    filter.addTo(map);
    return () => filter.remove();
  });
  return null;
};

LocationFilter.propTypes = {
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onCheck: PropTypes.func.isRequired,
};

export default LocationFilter;
